import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { setupSupabaseAuthStability } from "./lib/supabaseAuthStability";
import "./index.css";

setupSupabaseAuthStability();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
